// TODO enable eslint
/* eslint-disable no-nested-ternary */
import getWordByModelName from "./getWordByModelName"

export default function getCreateText(pending, dirty, modelName, isTitle) {
  return pending
    ? `Создание ${getWordByModelName(modelName, true)}${(isTitle && ` `) ||
        `...`}`
    : `Создать ${getWordByModelName(modelName)}`
}
